import axios from "axios";
import querystring from "querystring";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.xsrfCookieName = '_csrf';
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';
const token = localStorage.getItem('user-token');
const user = localStorage.getItem('user-id');
if (token && user) {
    axios.defaults.headers.common['X-Authorization'] = 'Bearer ' + token;
    axios.defaults.headers.common['X-User'] = user;
}

const config = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};

const getters = {
    ZAYAVKILIST: state => {
        return state.zayavkilist;
    },
    ZAYAVKIFILTERS: state => {
        return state.zayavkifiletrs;
    },
};
const mutations = {
    SET_ZAYAVKILIST: (state, payload) => {
        state.zayavkilist = payload;
    },

    SET_ZAYAVKIFILTERS: (state, payload) => {
        state.zayavkifiletrs = payload;
    },

    ADD_ZAYAVKILIST: (state, payload) => {
        state.zayavkilist.data.push(payload);
    },
    REMOVE_ZAYAVKILIST: (state, payload) => {
        state.zayavkilist.data = state.zayavkilist.data.filter(function(item) {
            return item.ID !== payload.id
        })
    },
};
const actions = {
    GET_ZAYAVKILIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/zayav/list?' + req).catch(err => {
            return err;
        });
        context.commit('SET_ZAYAVKILIST', data);
        return data;
    },
    GET_ZAYAVKILIST_NEW: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/zayav/listnew?' + req).catch(err => {
            return err;
        });
        return data;
    },
    EXCEL_ZAYAVKILIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/zayav/excellist?' + req).catch(err => {
            return err;
        });
        return data;
    },
    PDF_ZAYAVKILIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/zayav/pdflist?' + req).catch(err => {
            return err;
        });
        return data;
    },

    GET_ZAYAVKIFILETRS: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/zayav/filters?' + req);

        context.commit('SET_ZAYAVKIFILTERS', data);
        return data;
    },

    SAVE_ZAYAVKILIST: async (context, payload) => {
        const formData = new FormData();
        formData.append('IdStatiObject', payload.IdStatiObject);
        formData.append('Summa', payload.Summa);
        formData.append('PlanDate', payload.PlanDate);
        formData.append('IdZayavitel', payload.IdZayavitel);
        formData.append('IdSender', payload.IdSender);
        formData.append('IdReceiver', payload.IdReceiver);
        formData.append('Osnovanie', payload.Osnovanie);
        formData.append('IdClient', payload.IdClient);
        formData.append('TypeOrder', payload.TypeOrder);
        formData.append('percentProfit', payload.percent);
        let i = 0;
        for (let h of payload.houses) {
            formData.append('houses[' + i + '][ID]', h.ID);
            formData.append('houses[' + i + '][Summ]', h.Summ);
            formData.append('houses[' + i + '][IdStatii]', h.IdStatii);
            formData.append('houses[' + i + '][percentProfit]', h.percentProfit);
            let k = 0;
            for (let s of h.Statii)
            {
                formData.append('houses[' + i + '][Statii][' + k + '][ID]', s.ID);
                formData.append('houses[' + i + '][Statii][' + k + '][Summ]', s.Summ);
                formData.append('houses[' + i + '][Statii][' + k + '][IdStatii]', s.IdStatii);
                formData.append('houses[' + i + '][Statii][' + k + '][percentProfit]', s.percentProfit);
                k++;
            }
            i++;
        }
        if (payload.file) {
            formData.append('file', payload.file);
        }
        if (payload.filescore) {
            formData.append('filescore', payload.filescore);
        }

        let {data} = await axios.post('/budget-api/zayav/add', formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return data;
    },

    EDIT_ZAYAVKILIST: async (context, payload) => {
        let {data} = await axios.get('/budget-api/zayav/edit/' + payload.id);
        return data;
    },

    UPDATE_ZAYAVKILIST: async (context, payload) => {
        const formData = new FormData();
        formData.append('ID', payload.ID);
        formData.append('IdStatiObject', payload.IdStatiObject);
        formData.append('Summa', payload.Summa);
        formData.append('PlanDate', payload.PlanDate);
        formData.append('IdSender', payload.IdSender);
        formData.append('IdReceiver', payload.IdReceiver);
        formData.append('Osnovanie', payload.Osnovanie);
        formData.append('filescoreDelete', payload.filescoreDelete);
        formData.append('fileDelete', payload.fileDelete);
        formData.append('IdClient', payload.IdClient);
        formData.append('TypeOrder', payload.TypeOrder);
        formData.append('percentProfit', payload.percent);
        let i = 0;
        for (let h of payload.houses) {
            formData.append('houses[' + i + '][ID]', h.ID);
            formData.append('houses[' + i + '][Summ]', h.Summ);
            formData.append('houses[' + i + '][IdStatii]', h.IdStatii);
            formData.append('houses[' + i + '][percentProfit]', h.percentProfit);
            let k = 0;
            for (let s of h.Statii)
            {
                formData.append('houses[' + i + '][Statii][' + k + '][ID]', s.ID);
                formData.append('houses[' + i + '][Statii][' + k + '][Summ]', s.Summ);
                formData.append('houses[' + i + '][Statii][' + k + '][IdStatii]', s.IdStatii);
                formData.append('houses[' + i + '][Statii][' + k + '][Volume]', s.Volume);
                formData.append('houses[' + i + '][Statii][' + k + '][percentProfit]', s.percentProfit);
                k++;
            }
            i++;
        }
        if (payload.file) {
            formData.append('file', payload.file);
        }
        if (payload.filescore) {
            formData.append('filescore', payload.filescore);
        }
        let {data} = await axios.post('/budget-api/zayav/update',formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return data;
    },

    UPDATESTATE_ZAYAVKILIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/zayav/updatestate', req, config);
        return data;
    },

    SUMM_DIST_ZAYAVKA: async (context, payload) => {
        const formData = new FormData();
        formData.append('SummAllDist', payload.SummAllDist);
        let i = 0;
        for (let n of payload.numbObject) {
            formData.append('numbObject[' + i + ']', n);
            i++;
        }
        let {data} = await axios.post('/budget-api/zayav/summdist', formData, config);
        return data;
    },
    PLAN_STATII_ZAYAVKA: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/zayav/planstatii', req, config);
        return data;
    },
    DEL_ZAYAVKILIST: async (context, payload) => {
        const req = querystring.stringify({id: payload.id});
        await axios.post('/budget-api/zayav/del', req, config);
        context.commit('REMOVE_ZAYAVKILIST', payload);
    },
    PP_ZAYAVKA: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/zayav/ppfile', req, config);
        return data;
    },
};


export default {
    state: () => ({
        zayavkilist: null,
        zayavkifiletrs: null
    }),
    mutations,
    actions,
    getters
};
